import React from 'react';
import { Box, Button, Card, Typography, useTheme } from '@mui/material';

interface LinkTileProps {
    title: string;
    description: string;
    icon: React.ReactNode;
    linkText: string;
    onClick: () => void;
}

const LinkTile = ({ title, description, icon, linkText, onClick }: LinkTileProps) => {
    const theme = useTheme();

    return (
        <Card
            elevation={0}
            sx={{
                border: `solid 1px`,
                borderColor: theme.palette.grey['12p'],
                marginX: '0px',
                padding: '16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: '8px',
            }}
        >
            <Box>
                {icon}
                <Typography variant="h3" sx={{ fontSize: '18px', letterSpacing: '0.1px' }}>
                    {title}
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                    }}
                >
                    {description}
                </Typography>
            </Box>
            <Button
                size="large"
                variant="text"
                onClick={onClick}
                sx={{
                    alignSelf: 'flex-end',
                    padding: '4px 8px',
                }}
            >
                {linkText}
            </Button>
        </Card>
    );
};

export default LinkTile;
